import { useEffect, useState } from "react";
import CommonModal from "../modalLayout/CommonModal";

const AddnoteModal = ({
  show,
  setShow,
  formdata,
  onSave,
  confirmLoading = false,
  fieldName = "Note",
  title = "Add Internal Notes",
  placeholder = "Write notes",
}) => {
  const [draft, setDraft] = useState("");

  useEffect(() => {
    if (!show) return;
    setDraft(formdata?.[fieldName] || "");
  }, [show, fieldName]); // eslint-disable-line react-hooks/exhaustive-deps -- snapshot only when modal opens

  const handleConfirm = async () => {
    await onSave?.(draft);
  };

  const handleDiscard = () => {
    if (confirmLoading) return;
    setDraft(formdata?.[fieldName] || "");
    setShow?.(false);
  };

  return (
    <CommonModal
      className="modal-sm"
      show={show}
      setShow={setShow}
      title={title}
      centered
      onConfirm={handleConfirm}
      onCancel={handleDiscard}
      onHide={handleDiscard}
      confirmLabel="Confirm"
      confirmLoading={confirmLoading}
    >
      <textarea
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        className="textarea-cmn w-100"
        rows={6}
        placeholder={placeholder}
        disabled={confirmLoading}
      />
    </CommonModal>
  );
};

export default AddnoteModal;
